<template>
  <v-row dense>
    <v-col cols="12"  class="mt-1">
      <schedule-as-soon-as-posible
        v-model="deliveryTime"
      ></schedule-as-soon-as-posible>
    </v-col>
  </v-row>
</template>

<script>
import ScheduleAsSoonAsPosible from "@/modules/delivery/components-core/shared/ScheduleAsSoonAsPosible/ScheduleAsSoonAsPosible.vue";
import {
  AS_SON_AS_POSIBLE,
} from "@/modules/delivery/constants/OrderDelivery";

export default {
  name: "BarOrderModeSalon",
  components: { ScheduleAsSoonAsPosible },
  computed: {
    isCalendarActive() {
      return this.$store.state.orderStore.orderSystem.isCalendarTakeAwayActive();
    },
    isScheduled() {
      return this.$store.getters.orderSystem.order.isScheduled;
    },
    isAsSoonAsPosible() {
      return this.$store.getters.orderSystem.order.isAsSoonAsPossible;
    },
    deliveryTime: {
      get() {
        return this.$store.getters.deliveryTime;
      },
      set(value) {
        this.$store.commit("orderTime", value);
      },
    },
  },
  mounted() {
    this.$store.commit("orderTimeMode", AS_SON_AS_POSIBLE);
  },
};
</script>

<style scoped></style>
